export const bibleRouteNameRegex = /^bible-vids(___[a-z]{2})?$/;

export const commentaryRouteNameRegex = /^commentary-vids-type(___[a-z]{2})?$/;

export const commentRouteNameRegex = /^comment-nid(___[a-z]{2})?$/;

export const homeRouteNameRegex = /^index(___[a-z]{2})?$/;
